import React from 'react';

import { strings } from 'APP_ROOT/localization';
import RavenUtil, { BAD_INSTALLATION_STATES } from 'APP_ROOT/components/common/ravenUtil';
import StatusIcon from 'APP_ROOT/components/common/StatusIcon';
import { RESOURCE_ALERT_LEVEL } from 'APP_ROOT/components/pages/dashboard/ResourceGroups/constants';
import {TAG_TYPES_BADGES} from '../../../../../data/tags';

import EditableLabel from 'APP_ROOT/components/EditableLabel';

const VEHICLE_NAME_MAX_LENGTH = 50;

const BUTTON_VISIBILITY_ON_MAP_CLASS_NAME = "resource-visibility-on-map";

export default class Vehicle extends React.PureComponent {

    renderTags(tags) {
        const tagsByType = tags.reduce((acc, tag) => {
        if (acc[tag.type]) {
            acc[tag.type]++;
        } else {
            acc[tag.type] = 1;
        }
        return acc;
        }, {});
        
        return (
            <span className="tags-icons">
                {Object.keys(tagsByType).map((tagType, index) => {
                    
                    const badge = TAG_TYPES_BADGES[tagType];

                    if (!badge) return null;
                    
                    if(!tagsByType[tagType] === 0) return null;
                    
                    const title = strings[`tags_type_${tagType.toLowerCase()}_label`];

                    return (
                        <span key={index}>
                            <i title={title} className="tag-badge">{badge}</i>
                            <span>{tagsByType[tagType]}</span>
                        </span>
                    );
                })}
            </span>
        )
    }

    renderStatusInfo(raven) {

        var content = null;

        const isIdling = raven.isIdling ? true : false; // collapsing nulls and falses to false
        const hasActiveDTC = raven.vehicle && raven.vehicle.activeDTCs && raven.vehicle.activeDTCs.length > 0;
        const shutdownByUser = RavenUtil.isShutdownByUser(raven.dashboard) ? true : false; // collapsing nulls and falses to false
        const lowBatteryShutdown = RavenUtil.isShutDownForLowBattery(raven.dashboard) ? true : false;
        const badInstallState = RavenUtil.getBadInstallState(raven.dashboard);

        if (raven.isDriving === true) {
            const { currentSpeed } = this.props;

            if (!currentSpeed && currentSpeed !== 0) return null;

            const speedValue = Math.round(RavenUtil.convertDistance(currentSpeed, this.props.unitOfMeasure));
            const speedUnitsString = this.props.unitOfMeasure === "METRIC" ? ' kph' : ' mph';
            content = (
                <span className="speed-badge">
                    <span className="speed">{speedValue}</span>
                    <span className="units">{speedUnitsString}</span>
                </span>
            );

            if (isIdling) {
                content = <img className="icon-idling" src="/svg/icon-idling-status.svg" alt="Idling" title={strings.status_idling} />;
            }

        } else if (raven.isDriving === false) {
            content = <StatusIcon theme={this.props.theme} type="parked" />;
        } else {
            // Unknown state at the moment
            content = null;
        }

        return (
            <span className="status-icons">
                { this.renderSuspended() }
                { this.renderWarningBadge() }
                { this.renderBadInstallation(badInstallState) }
                { this.renderDTCBadge(hasActiveDTC) }
                { lowBatteryShutdown ? this.renderLowBatteryShutdown(lowBatteryShutdown) : shutdownByUser ? this.renderUserShutdown(shutdownByUser) : this.renderUnplugged(raven.unplugged) }
                { raven.vehicleState && !raven.unplugged && !shutdownByUser ? this.renderOffline(raven.vehicleState.ravenOffline) : null }
                { this.renderSDCard(raven.sdCardStatus) }

                {content}
            </span>
        )
    }

    renderWarningBadge() {
        const {warningLevel} = this.props;
        if (warningLevel === RESOURCE_ALERT_LEVEL.SEVERE) {
            return (
                <StatusIcon theme={this.props.theme} type="alert" title={strings.status_alert} />
            );
        }
    }

    renderSuspended() {
        if (this.props.raven.status === "SUSPENDED") {
            return (
                <StatusIcon theme={this.props.theme} type="suspended" title={strings.status_suspended} />
            );
        }
    }

    renderSDCard(sdCardStatus) {

        var content;
        if(sdCardStatus === "INSERTED")
        {
            return null;
        }
        else if(sdCardStatus === "REMOVED")
        {
            return ( <StatusIcon theme={this.props.theme} type="sdcard-no" title={document.getSDCardStatusName(sdCardStatus)}/> );
        }
        else if (sdCardStatus !== "UNKNOWN") // unknown is used by default for case(s) like raven is unplugged
        {
            return ( <StatusIcon theme={this.props.theme} type="sdcard-alert" title={document.getSDCardStatusName(sdCardStatus)} /> );
        }
    }

    renderOffline(ravenOffline) {
        if(ravenOffline)
        {
            return (<StatusIcon theme={this.props.theme} type="offline" title={strings.status_offline} /> );
        }
    }

    renderDTCBadge(activeDTC) {
        // FIXME
        return null;

        /*
        if (activeDTC) {
            return (
                <StatusIcon theme={this.props.theme} type="dtc-active" title={strings.status_dtc_alert} />
            );
        }
        */
    }

    renderUnplugged(ravenUnplugged) {
        if(ravenUnplugged)
        {
            return (
                <StatusIcon theme={this.props.theme} type="unplugged" title={strings.status_unplugged} />
            );
        }
    }

    renderUserShutdown(shutdownByUser) {
        if (shutdownByUser) {
            return (
                <StatusIcon theme={this.props.theme} type="unplugged" title={strings.status_user_shutdown} />
            );
        }
    }

    renderLowBatteryShutdown(lowBatteryShutdown) {
        if (lowBatteryShutdown) {
            return (
                <StatusIcon theme={this.props.theme} type="car-battery-low" title={strings.status_low_battery_shutdown} />
            );
        }
    }

    renderBadInstallation(badInstallState) {
        switch (badInstallState) {
            case BAD_INSTALLATION_STATES.DETECTED:
                return (
                    <StatusIcon theme={this.props.theme} type="bad-installation-detected" title={strings.event_title_bad_install_detected} />
                );
            case BAD_INSTALLATION_STATES.CLEARED:
            default:
                return null;
        }
    }

    renderNoServicePlanLabel(raven) {
        return (
            <span className="service-plan-description">
                {strings.formatString(strings.no_plan_label)}
            </span>
        )
    }

    startEditing = () => {
        this.props.setEditingVehicleName(this.props.raven, true);
    }

    stopEditing = () => {
        this.props.setEditingVehicleName(this.props.raven, false);
    }

    changeVehicleName = (newName) => {
        this.props.changeVehicleName(this.props.raven, newName);
        this.props.setEditingVehicleName(this.props.raven, false);
    }

    selectItem = (ravenId, hidden) => {
        const visible = !hidden;
        this.props.onSelectResource('vehicle', ravenId, visible);
    }

    canEditVehicleName = () => {
        return this.props.raven.canEdit;
    }

    render() {

        const {
            raven,
            tags,
            selected,
            warningLevel,
            features
        } = this.props;

        let resourceClasses = ["resource"];
        if (selected) resourceClasses.push("selected");
        
        resourceClasses.push("alert_level " + warningLevel);

        var facialRecognitionEnabled = features && features.facial_recognition;

        if (raven.isDriving === false) {
            facialRecognitionEnabled = false; // effectively, do not show unknown_driver/no_driver_detected for parked cards
        }

        var driverName = "";
        if (facialRecognitionEnabled) {
            if (raven.vehicle && raven.vehicle.currentDriver) {
                if (raven.vehicle.currentDriver.name) {
                    driverName = raven.vehicle.currentDriver.name;
                } else {
                    driverName = strings.unknown_driver;
                }
            } else {
                driverName = strings.no_driver_detected;
            }
        }
        var ravenInfoLabel = <span className="info">{driverName}</span>; // default is a blank paragraph to be added under the raven vehicle name header

        return (
            <li className={resourceClasses.join(" ")} onClick={ (event) => {
                const parentNode = event.target.parentNode;
                if (parentNode.className &&
                    parentNode.className instanceof String && // "className" can be seemingly unrelated objects for SVG elements
                    parentNode.className.includes(BUTTON_VISIBILITY_ON_MAP_CLASS_NAME)) {
                    this.selectItem(raven.ravenUuid, !raven.hidden); // visibility is being toggled on this click
                    return;
                }
                this.selectItem(raven.ravenUuid, raven.hidden)
            }}>
                <header className="resource-header">
                    <h3 className="resource-name">
                        <EditableLabel
                            value={raven.vehicle._pendingName || raven.vehicle.name}
                            editing={this.props.editingVehicleName}
                            loading={this.props.vehicleNameChangePending}
                            onRequestEdit={this.startEditing}
                            onChange={this.changeVehicleName}
                            onCancel={this.stopEditing}
                            maxLength={VEHICLE_NAME_MAX_LENGTH}
                            canEdit={this.canEditVehicleName()}
                        />
                    </h3>
                    {raven.noServicePlan ?
                        this.renderNoServicePlanLabel() : null /* phrase contained in a span wrapper */
                    }
                    {ravenInfoLabel/* phrase/name contained in a span wrapper */}
                </header>
                <button className={BUTTON_VISIBILITY_ON_MAP_CLASS_NAME} onClick={() => this.props.setVisible(raven.ravenUuid, raven.hidden)}>
                    {raven.hidden ?
                        <i className="material-icons unchecked">check_box_outline_blank</i> :
                        <i className="material-icons checked">check_box</i>
                    }
                </button>
                {!raven.noServicePlan ?
                    this.props.badgesView === 'status' ? this.renderStatusInfo(raven) : this.renderTags(tags)
                    : null /* different types (i, img, spans) contained in a span wrapper */
                }
            </li>
        );
    }
}
